export default __webpack_public_path__ + "static/media/tick.f9d09500.png";